import _ from "lodash";
import PouchDB from "pouchdb";

////////////////////////////////////////////////////////////////////// Accessors

const getClients = (db, effect) => {
  db.allDocs({ include_docs: true })
    .then(all => all.rows.map(r => r.doc.client))
    .then(effect)
    .catch(console.log);
};

const getClient = (db, id, effect) => {
  db.get(id)
    .then(effect)
    .catch(console.log);
};

const getCommandes = db => id => effect => {
  db.allDocs({ include_docs: true })
    .then(ds => ds.rows.map(d => d.doc.commande))
    .then(cs => _.filter(cs, c => c.client.numero == id))
    .then(effect)
    .catch(console.log);
};

////////////////////////////////////////////////////////////////////// Effectors

/**************

store commande db =
  numero existant ?
    nom identique ?
      sauve commande
    nom different ?
      alerte
  sinon
    sauve client
    sauve commande


**************/

// StoreAction = OrderOnly | OrderAndClient | Conflict
//+ db -> commande -> Promise<StoreAction>
async function store(databases, commande, client) {
    let { commandes, customers } = databases;
    let { uid } = commande
    let { nom, numero } = client
    try {
        const doc = await customers.get(numero)
        let stored = doc.client
        if (stored.nom === nom) {
            console.log('[save] existing')
            const put = await commandes.put({ _id: uid, commande })
            return { storeAction: 'orderOnly', data: { stored, client, commande, put } }
        } else {
            console.log('[save] conflict')
            return { storeAction: 'conflict', data: { stored, client, commande } }
        }
    } catch (e) {
        console.log('[save] fullnew', client, commande)
        const cup = await customers.put({ _id: numero, client })
        const cop = await commandes.put({ _id: uid, commande })
        return { storeAction: 'orderAndClient', data: { client, commande, cup, cop } }
    }
}

///////////////////////////////////////////////////////////////////// Management

async function exportdb() {
  let alljson = base =>
    this.$db[base].allDocs({ include_docs: true }).then(JSON.stringify);
  let promises = await Promise.all(this.bases.map(alljson));
  console.log(promises);
}

const reset = (db, name) => {
  db[name]
    .destroy()
    .then(() => {
      console.log("wipe db...", db, name);
      db[name] = new PouchDB(name);
      console.log("recreated db...", db, name);
    })
    .catch(console.log);
};

const bestClient = db => {
  let cs = [];
  getClients(db, _ => (cs = _));
  let countCommandes = (db, cid) => {
    let cs = [];
    getCommandes(db, cid, _ => (cs = _));
    return cs.length;
  };
  let sorted = _.sortBy(cs, c => countCommandes(db, c.id));
  return sorted[0];
};

const bestMenu = db =>
  new Promise((r, e) => {
    db.allDocs({ include_docs: true })
      .then(ds => ds.rows.map(d => d.doc.commande))
      .then(r)
      .catch(_ => {
        console.log("[bestMenu]", _);
        e(_);
      });
  });

///////////////////////////////////////////////////////////////////////// Export

/**
 * nested doc needs to be flipped, DFS order
 * then linearized
 * then mapped into SQL
 * and reduced since each statement may depend on the previous
 **/

export {
  store,
  exportdb,
  reset,
  getClients,
  getClient,
  getCommandes,
  bestClient,
  bestMenu
};
